import {CompetitionInsightsPageRouteMetaDataModel} from "./competition-insights-page.route.meta-data.model";
import {PAGES} from "../../../../../core/consts";
import {CompetitionPageRouteConfig} from "../../../models/competition.page-route.config";

export class CompetitionInsightsPageRouteConfig extends CompetitionPageRouteConfig {
  static injectables = [];

  constructor() {
    super({
      name: PAGES.COMPETITION.insights,
      path: `insights`,
      componentImport: () => import("../components/competition-insights-page" /* webpackChunkName: "competition-insights-page" */ ),
      metadataType: CompetitionInsightsPageRouteMetaDataModel
    });
  }
}